import type { TourPeriod } from "../types/history";

// Сегодняшняя дата/час для плейсхолдеров вычисляется в часовом поясе Алматы.
export const TIMEZONE = "Asia/Almaty";

// Номинальное время запуска кронов — используется как «дедлайн» для плейсхолдеров сегодняшнего дня
// (запланировано / не выполнено).
export const NOMINAL_RUN_HOUR: Record<TourPeriod, number> = {
  morning: 9,
  afternoon: 13,
  evening: 17,
};

export const PERIOD_ORDER: TourPeriod[] = ["morning", "afternoon", "evening"];

export const PERIOD_LABELS: Record<TourPeriod, string> = {
  morning: "Утро",
  afternoon: "День",
  evening: "Вечер",
};
